// Shop copy: the Shop page + the « the game for real » gallery.
// Translation of fr/shop.js — exactly the same keys.
// Product copy (name, description, features of the packs) is NOT here:
// it comes from the database via tp()/tpList() (see LanguageContext).
export default {
  'shop.seo.titre': 'Shop - Gender reveal puzzles',
  'shop.seo.description':
    "Two Joyful Reveal packs to reveal your baby's sex with the family. Delivery in Belgium, France, Luxembourg, the Netherlands, Germany and Spain.",

  'shop.page.chargement': 'Loading the shop...',

  // schema.org structured data (CollectionPage) injected into the <head>.
  'shop.schema.nom': 'Mirum Games shop',
  'shop.schema.description': 'Discover all our Joyful Reveal packs',

  'shop.entete.badge': '🛍️ Our shop',
  'shop.entete.titre': 'Joyful Reveal - Bears',
  'shop.entete.texte':
    'Choose the perfect pack for your magical moment. Every puzzle is a special creation for your family.',

  // Choice helper: the sentence is cut into segments because the two pack names
  // sit inside <strong> in the JSX. seg1+seg2+seg3+seg4+seg5 = the whole
  // sentence; the leading and trailing spaces of the segments matter. The pack
  // names are the ones set in en/common.js.
  'shop.aide.titre': 'Two packs, one game',
  'shop.aide.seg1': 'The ',
  'shop.aide.seg2': 'Essential Pack',
  'shop.aide.seg3': ' if you are writing your own questions and sorting out your teams. The ',
  'shop.aide.seg4': 'Premium Pack',
  'shop.aide.seg5':
    ' if you want everything to arrive ready to go: the pouches, the printed questionnaire and the keepsake envelope.',

  // Product fallbacks: used only if the database supplies neither description
  // nor features (should not happen) — these are not packs.* keys.
  'shop.produit.descriptionRepli':
    'Discover this Joyful Reveal pack for an unforgettable gender reveal party!',
  'shop.produit.repliDuo1': '2 game boxes',
  'shop.produit.repliDuo2': 'Great-value pack',
  'shop.produit.repliDuo3': 'Ideal for 2 parties',
  'shop.produit.repliFamille1': '3 complete kits',
  'shop.produit.repliFamille2': 'Best value for money',
  'shop.produit.repliFamille3': 'Ideal for big families',
  'shop.produit.repliPremium1': 'Complete game',
  'shop.produit.repliPremium2': 'Accessories included',
  'shop.produit.repliPremium3': 'Premium quality',
  'shop.produit.repliMixte1': 'Girl + boy version',
  'shop.produit.repliMixte2': 'Ideal for twins',
  'shop.produit.repliMixte3': 'Complete pack',
  'shop.produit.repliDefaut1': 'Gender reveal game box',
  'shop.produit.repliDefaut2': 'Handcrafted',
  'shop.produit.repliDefaut3': 'Fast delivery',

  // Name of the item as it enters the basket.
  'shop.panier.nomArticle': 'Joyful Reveal - Bears - {nom}',
  'shop.panier.suffixeGarcon': ' (Boy)',
  'shop.panier.suffixeFille': ' (Girl)',

  'shop.grille.altPhoto': '{nom} — Joyful Reveal gender reveal game, product photo',
  'shop.grille.rupture': '❌ OUT OF STOCK',
  'shop.grille.bientotRetour': 'Back in stock soon',
  'shop.grille.enStock': 'In stock',
  'shop.grille.voirPlus': 'Show more',
  'shop.grille.autresCaracteristiques': '+{n} more',
  'shop.grille.epuise': 'Sold out',
  'shop.grille.ajoute': '✓ Added!',
  'shop.grille.ajouter': '🛒 Add',
  'shop.grille.versPanier': '→ Basket',
  'shop.grille.ficheComplete': '📋 See the full product page',

  'shop.vide.titre': 'No pack found',
  'shop.vide.texte': 'Try another filter',

  'shop.pourquoi.titre': 'Why choose Joyful Reveal?',
  'shop.pourquoi.emballageTitre': 'Premium packaging',
  'shop.pourquoi.emballageTexte':
    'Every puzzle arrives in elegant gift packaging, ready to give or to open together.',
  'shop.pourquoi.jeuTitre': 'Interactive game',
  'shop.pourquoi.jeuTexte':
    'A one-of-a-kind concept that turns the reveal into a game everyone joins in with, built around fun questions and answers.',
  'shop.pourquoi.assemblageTitre': 'Easy to put together',
  'shop.pourquoi.assemblageTexte':
    'A puzzle designed to be assembled easily as a family while the question-and-answer game plays out.',
  'shop.pourquoi.momentTitre': 'Magical moment',
  'shop.pourquoi.momentTexte':
    'Create an unforgettable memory by revealing your baby’s sex together, as a family.',
  'shop.pourquoi.expeditionTitre': 'Shipped from Belgium',
  'shop.pourquoi.expeditionTexte':
    'On its way within 1 to 2 working days to Belgium, France and Luxembourg. Reinforced packaging.',
  'shop.pourquoi.retractationTitre': '14 days to change your mind',
  'shop.pourquoi.retractationTexte':
    'A 14-day right of withdrawal from the day your order arrives, exactly as European law on online purchases provides.',

  'shop.cta.titre': 'Ready to live the magical reveal?',
  'shop.cta.texte': 'Choose your pack and create an unforgettable moment with your family',
  'shop.cta.bouton': '🛒 Discover the packs',

  'shop.modale.titre': 'It’s for...',
  'shop.modale.sousTitre': 'Choose the sex for your puzzle',
  'shop.modale.garcon': 'Boy',
  'shop.modale.fille': 'Girl',
  'shop.modale.annuler': 'Cancel',

  'shop.galerie.titre': 'The real thing',
  'shop.galerie.sousTitre':
    'Photos of the product exactly as you receive it — no nasty surprises.',
  'shop.galerie.agrandir': 'Enlarge photo: {titre}',
  'shop.galerie.fermer': 'Close',
  'shop.galerie.boiteRectoTitre': 'The box',
  'shop.galerie.boiteRectoLegende': 'The Joyful Reveal game, ready to give.',
  'shop.galerie.boiteRectoAlt':
    'Joyful Reveal game box: two teddy bears, scratch puzzle piece “GIRL or BOY?”',
  'shop.galerie.contenuTitre': 'What you receive',
  'shop.galerie.contenuLegende':
    'The box, the keepsake quiz sheet and the two team pouches.',
  'shop.galerie.contenuAlt':
    'Full contents of the Joyful Reveal game: the box, the keepsake quiz sheet and the two cotton pouches',
  'shop.galerie.pochonsTitre': 'The two teams',
  'shop.galerie.pochonsLegende': 'Two cotton pouches, one for Team 1 and one for Team 2.',
  'shop.galerie.pochonsAlt':
    'The two cotton pouches from the game, labelled Team 1 and Team 2, illustrated with teddy bears',
  'shop.galerie.boiteVersoTitre': 'How to play',
  'shop.galerie.boiteVersoLegende': 'The 4 steps of the game, 2 to 10 players, about 20 minutes.',
  'shop.galerie.boiteVersoAlt':
    'Back of the Joyful Reveal box detailing the 4 steps of the game, for 2 to 10 players, 20 minutes',
};
